const allSlices = {};
const initialState = {};

function importAll(r) {
  Object.entries(r).forEach(([, module]) => {
    const { initialState: sliceInitialState, slice } = module;

    initialState[slice.name] = sliceInitialState;
    allSlices[slice.name] = slice;
  });
}

importAll(import.meta.glob('./**/*-slice.{js,ts}', { eager: true }));

export { allSlices, initialState };
